import React from 'react';

/**
 * Stilar för de publika sidorna som nås via länk utan inloggning
 * (avvikelse, ledighet, guide, egenkontroll): grå bakgrund och ett vitt kort.
 */
export const publicBodyStyle: React.CSSProperties = {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    margin: 0, padding: '24px', background: '#f5f5f5', color: '#222', minHeight: '100vh',
};

export const publicCardStyle = (maxWidth = 600): React.CSSProperties => ({
    background: 'white', borderRadius: '12px', padding: '32px', maxWidth: `${maxWidth}px`,
    margin: '0 auto', boxShadow: '0 2px 12px rgba(0,0,0,.1)',
});

/** Sidmall: bakgrund plus kort. Barnen hamnar i kortet. */
const PublicPage: React.FC<{ maxWidth?: number; children: React.ReactNode }> = ({ maxWidth = 600, children }) => (
    <div style={publicBodyStyle}>
        <div style={publicCardStyle(maxWidth)}>{children}</div>
    </div>
);

export default PublicPage;
